/**
 * PL▲YBACK (the review room) — client-surface strings.
 *
 * Started with the plan-gating panel (PR 6 of the Playback-SaaS
 * stream); the full player surface joins in the i18n pass (PR 9).
 * Writing rules: sentences for bodies, no trailing periods on
 * titles/buttons, {slot} interpolation.
 */
export const playback = {
  /** Solo/no-plan panel title — review is a Studio+Agency feature. */
  'playback.upsellTitle': 'Client review is part of Studio',
  /** Body under the title. */
  'playback.upsellBody':
    'Upload rendered cuts, stack versions, and take sign-off in writing on the same link your client already has. Included with Studio and Agency plans.',
  /** Button to the plan settings. */
  'playback.upsellCta': 'View plans',
  /** Primary control in the PL▲YBACK room: hands a rendered cut to
   *  the upload tray. */
  'playback.addCut': 'Add cut',
  /** Header button: starts a NEW cut (a fresh video in this project),
   *  named from the file. Versions of an existing cut go via newVersion. */
  'playback.newCut': 'New cut',
  /** In-player action: upload the next version of the OPEN cut. */
  'playback.newVersion': 'New version',
  /** Asked when a long file is dropped into Cuts. {minutes} = whole minutes. */
  'playback.longFilePrompt':
    'This file runs {minutes} minutes, so it looks like interview footage rather than a cut for review. Add it to A-Roll for a transcript and paper edit instead?',
  /** Confirm button on that prompt. */
  'playback.longFileToAroll':
    'Add to A-Roll',
  /** Decline button on that prompt. */
  'playback.longFileAsCut':
    'Upload as a cut',
} as const;
